import TemplateAttributesList from "../components/templates/TemplateAttributesList";

export default function TemplateAttributes() {
  return <TemplateAttributesList />;
}